module.exports = __webpack_public_path__ + "img/_Anna.97c91d05.png";